export default __webpack_public_path__ + "static/blob4-77e2d09f463d3efcf70492e29156d56a.svg";